import React, { useEffect, useMemo, useState } from "react";
import "./CatalogGallery.scss";

const catalogCategories = [
  {
    slug: "canceles",
    title: "Canceles",
    cover: "/images/catalog/canceles/cancel-1.jpg",
    description:
      "Canceles de cristal templado para baño y espacios interiores con diseño moderno y excelente presentación.",
    images: [
      "/images/catalog/canceles/cancel-1.jpg",
      "/images/catalog/canceles/cancel-2.jpg",
      "/images/catalog/canceles/cancel-3.jpg",
      "/images/catalog/canceles/cancel-4.jpg",
      "/images/catalog/canceles/cancel-5.jpg",
      "/images/catalog/canceles/cancel-6.jpg",
      "/images/catalog/canceles/cancel-7.jpg",
      "/images/catalog/canceles/cancel-8.jpg",
      "/images/catalog/canceles/cancel-9.jpg",
      "/images/catalog/canceles/cancel-10.jpg",
      "/images/catalog/canceles/cancel-11.jpg",
    ],
  },
  {
    slug: "fachadas",
    title: "Fachadas",
    cover: "/images/catalog/fachadas/fachada-1.jpg",
    description:
      "Soluciones en vidrio y aluminio para fachadas, cerramientos y accesos con imagen moderna y profesional.",
    images: [
      "/images/catalog/fachadas/fachada-1.jpg",
      "/images/catalog/fachadas/fachada-2.jpg",
      "/images/catalog/fachadas/fachada-3.jpg",
    ],
  },
  {
    slug: "barandales",
    title: "Barandales",
    cover: "/images/catalog/barandales/barandal-1.jpg",
    description:
      "Barandales de vidrio templado con diseño limpio, seguridad y gran impacto visual para interiores o exteriores.",
    images: [
      "/images/catalog/barandales/barandal-1.jpg",
      "/images/catalog/barandales/barandal-2.jpg",
      "/images/catalog/barandales/barandal-3.jpg",
      "/images/catalog/barandales/barandal-4.jpg",
      "/images/catalog/barandales/barandal-5.jpg",
      "/images/catalog/barandales/barandal-6.jpg",
      "/images/catalog/barandales/barandal-7.jpg",
    ],
  },
  {
    slug: "oficinas",
    title: "Oficinas",
    cover: "/images/catalog/oficinas/oficina-1.jpg",
    description:
      "Divisiones de cristal y soluciones para oficinas, corporativos y espacios de trabajo funcionales.",
    images: [
      "/images/catalog/oficinas/oficina-1.jpg",
      "/images/catalog/oficinas/oficina-2.jpg",
      "/images/catalog/oficinas/oficina-3.jpg",
      "/images/catalog/oficinas/oficina-4.jpg",
      "/images/catalog/oficinas/oficina-5.jpg",
      "/images/catalog/oficinas/oficina-6.jpg",
      "/images/catalog/oficinas/oficina-7.jpg",
      "/images/catalog/oficinas/oficina-8.jpg",
      "/images/catalog/oficinas/oficina-9.jpg",
    ],
  },
  {
    slug: "puertas-ventanas",
    title: "Puertas y ventanas",
    cover: "/images/catalog/puertas-ventanas/ventana-1.jpg",
    description:
      "Puertas y ventanas de aluminio para proyectos residenciales y comerciales con gran durabilidad y estilo.",
    images: [
      "/images/catalog/puertas-ventanas/ventana-1.jpg",
      "/images/catalog/puertas-ventanas/ventana-2.jpg",
      "/images/catalog/puertas-ventanas/ventana-3.jpg",
      "/images/catalog/puertas-ventanas/ventana-4.jpg",
      "/images/catalog/puertas-ventanas/ventana-5.jpg",
      "/images/catalog/puertas-ventanas/ventana-6.jpg",
      "/images/catalog/puertas-ventanas/ventana-7.jpg",
      "/images/catalog/puertas-ventanas/ventana-8.jpg",
      "/images/catalog/puertas-ventanas/ventana-9.jpg",
      "/images/catalog/puertas-ventanas/ventana-10.jpg",
      "/images/catalog/puertas-ventanas/ventana-11.jpg",
      "/images/catalog/puertas-ventanas/ventana-12.jpg",
      "/images/catalog/puertas-ventanas/ventana-13.jpg",
      "/images/catalog/puertas-ventanas/ventana-14.jpg",
      "/images/catalog/puertas-ventanas/ventana-15.jpg",
      "/images/catalog/puertas-ventanas/ventana-16.jpg",
    ],
  },
  {
    slug: "especiales",
    title: "Proyectos especiales",
    cover: "/images/catalog/especiales/especial-1.jpg",
    description:
      "Soluciones personalizadas en vidrio y aluminio para requerimientos específicos y proyectos a medida.",
    images: [
      "/images/catalog/especiales/especial-1.jpg",
      "/images/catalog/especiales/especial-2.jpg",
      "/images/catalog/especiales/especial-3.jpg",
      "/images/catalog/especiales/especial-4.jpg",
      "/images/catalog/especiales/especial-5.jpg",
    ],
  },
];

const CatalogGallery = () => {
  const [selectedCategorySlug, setSelectedCategorySlug] = useState(null);
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);

  const selectedCategory = useMemo(() => {
    return (
      catalogCategories.find(
        (category) => category.slug === selectedCategorySlug
      ) || null
    );
  }, [selectedCategorySlug]);

  useEffect(() => {
    if (selectedCategory) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [selectedCategory]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!selectedCategory) return;

      if (e.key === "Escape") {
        closeModal();
      }

      if (e.key === "ArrowLeft") {
        goPrev();
      }

      if (e.key === "ArrowRight") {
        goNext();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  });

  const openCategoryModal = (slug) => {
    setSelectedCategorySlug(slug);
    setSelectedImageIndex(0);
  };

  const closeModal = () => {
    setSelectedCategorySlug(null);
    setSelectedImageIndex(0);
  };

  const goPrev = () => {
    if (!selectedCategory) return;

    setSelectedImageIndex((prev) =>
      prev === 0 ? selectedCategory.images.length - 1 : prev - 1
    );
  };

  const goNext = () => {
    if (!selectedCategory) return;

    setSelectedImageIndex((prev) =>
      prev === selectedCategory.images.length - 1 ? 0 : prev + 1
    );
  };

  const handleThumbnailClick = (index) => {
    setSelectedImageIndex(index);
  };

  return (
    <section className="catalog-gallery" id="catalogo">
      <div className="catalog-gallery__container">
        <div className="catalog-gallery__top">
          <span className="catalog-gallery__eyebrow">Catálogo interactivo</span>

          <div className="catalog-gallery__heading">
            <h2 className="catalog-gallery__title">
              Explora nuestros trabajos por tipo de servicio
            </h2>

            <p className="catalog-gallery__intro">
              Selecciona la categoría que te interesa y visualiza únicamente los
              proyectos relacionados con ese tipo de trabajo.
            </p>
          </div>
        </div>

        <div className="catalog-gallery__grid">
          {catalogCategories.map((category) => (
            <button
              type="button"
              className="catalog-gallery__card"
              key={category.slug}
              onClick={() => openCategoryModal(category.slug)}
            >
              <div className="catalog-gallery__image-wrapper">
                <img
                  src={category.cover}
                  alt={category.title}
                  className="catalog-gallery__image"
                />

                <div className="catalog-gallery__overlay">
                  <span className="catalog-gallery__badge">
                    {category.images.length} fotos
                  </span>

                  <h3 className="catalog-gallery__card-title">
                    {category.title}
                  </h3>

                  <p className="catalog-gallery__card-description">
                    {category.description}
                  </p>
                </div>
              </div>
            </button>
          ))}
        </div>
      </div>

      {selectedCategory && (
        <div className="catalog-gallery__modal" onClick={closeModal}>
          <div
            className="catalog-gallery__modal-shell"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="catalog-gallery__modal-content">
              <button
                type="button"
                className="catalog-gallery__close"
                onClick={closeModal}
                aria-label="Cerrar modal"
              >
                ×
              </button>

              <div className="catalog-gallery__modal-header">
                <div>
                  <span className="catalog-gallery__modal-label">Categoría</span>
                  <h3 className="catalog-gallery__modal-title">
                    {selectedCategory.title}
                  </h3>
                </div>

                <p className="catalog-gallery__modal-count">
                  {selectedImageIndex + 1} / {selectedCategory.images.length}
                </p>
              </div>

              <div className="catalog-gallery__viewer">
                <button
                  type="button"
                  className="catalog-gallery__nav catalog-gallery__nav--prev"
                  onClick={goPrev}
                  aria-label="Imagen anterior"
                >
                  ‹
                </button>

                <div className="catalog-gallery__main-image-box">
                  <img
                    src={selectedCategory.images[selectedImageIndex]}
                    alt={`${selectedCategory.title} ${selectedImageIndex + 1}`}
                    className="catalog-gallery__main-image"
                  />
                </div>

                <button
                  type="button"
                  className="catalog-gallery__nav catalog-gallery__nav--next"
                  onClick={goNext}
                  aria-label="Siguiente imagen"
                >
                  ›
                </button>
              </div>

              <div className="catalog-gallery__thumbnails">
                {selectedCategory.images.map((image, index) => (
                  <button
                    type="button"
                    key={image}
                    className={`catalog-gallery__thumbnail ${
                      selectedImageIndex === index ? "is-active" : ""
                    }`}
                    onClick={() => handleThumbnailClick(index)}
                  >
                    <img
                      src={image}
                      alt={`${selectedCategory.title} miniatura ${index + 1}`}
                    />
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default CatalogGallery;